import React from "react";

const objectivesData = [
  {
    title: "Course Objectives:",
    items: [
      "Provide an in-depth understanding of global political governance principles, frameworks, and systems.",
      "Develop critical analysis and strategic thinking skills for addressing complex political and governance challenges.",
      "Cultivate advanced communication and negotiation skills essential for political leadership and diplomacy.",
      "Foster an appreciation of cultural diversity and inclusivity in political and diplomatic contexts.",
      "Equip participants with the ability to design and implement innovative, sustainable political initiatives.",
    ],
    color: "text-green-600",
  },
  {
    title: "Course Outcomes:",
    items: [
      "Demonstrate advanced knowledge of global political systems and governance structures.",
      "Critically analyse and evaluate policy-making processes to propose innovative and sustainable solutions.",
      "Exhibit superior oral and written communication skills for effective political advocacy and leadership.",
      "Apply advanced theoretical frameworks to real-world political and governance challenges.",
      "Display leadership and strategic planning skills to drive impactful political and diplomatic initiatives.",
    ],
    color: "text-purole-600",
  },
];

const ObjectivesEP = () => {
  return (
    <div className="my-10 " id="objectives">
      <div className="max-w-6xl mx-auto bg-sdbodywhiteywhitebody bg-opacity-70 shadow-lg rounded-lg p-8">

        <div className="md:flex md:gap-8 space-y-5 md:space-y-0">
          {objectivesData.map((section, index) => (
            <div key={index} className="md:w-1/2">
              <h3
                className={`text-lg md:text-2xl font-semibold mb-4 ${section.color}`}
              >
                {section.title}
              </h3>
              <ul className="space-y-4 list-disc list-inside">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <img
                      src="/image-fix/pointers/inspiration-svgrepo-com.svg"
                      alt="icon"
                      className="w-8 h-8 mt-1"
                    />
                    <span className="text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ObjectivesEP;
